module.exports = __webpack_public_path__ + "img/xiezuo.fb75c8c5.png";